<template>
    <div class="sm:w-full md:w4/5 lg:w-3/5 mx-auto md:p-6">
        <!-- Events Grid -->
        <div v-if="eventsSorted.length > 0" class="space-y-4">
            <div
v-for="event in eventsSorted" :key="event.id"
                class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition-all duration-200"
                :class="{
                    'ring-2 ring-red-400 border-red-400': daysUntilNextAnniversary(event.date) < 1,
                    'ring-2 ring-orange-400 border-orange-400': daysUntilNextAnniversary(event.date) === 1,
                    'ring-1 ring-yellow-400 border-yellow-400': daysUntilNextAnniversary(event.date) < 7 && daysUntilNextAnniversary(event.date) > 1
                }"
>
                <div class="p-6">
                    <div class="flex items-center justify-between">
                        <!-- Left Side: Icon and Event Info -->
                        <div class="flex items-center space-x-4">
                            <!-- Icon -->
                            <div
class="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center" :class="{
                                'bg-pink-100': event.event === 'birthday',
                                'bg-purple-100': event.event === 'anniversary',
                                'bg-blue-100': !['birthday', 'anniversary'].includes(event.event)
                            }"
>
                                <div v-if="event.event === 'birthday'" class="w-6 h-6 text-pink-600">
                                    <svg
xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-cake-icon lucide-cake"
>
                                        <path d="M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8" />
                                        <path d="M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1" />
                                        <path d="M2 21h20" />
                                        <path d="M7 8v3" />
                                        <path d="M12 8v3" />
                                        <path d="M17 8v3" />
                                        <path d="M7 4h.01" />
                                        <path d="M12 4h.01" />
                                        <path d="M17 4h.01" />
                                    </svg>
                                </div>
                                <div v-else-if="event.event === 'anniversary'" class="w-6 h-6 text-purple-600">
                                    <svg
xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"
>
                                        <path
                                            d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
/>
                                    </svg>
                                </div>
                                <div v-else-if="event.event === 'Mothers Day'" class="w-6 h-6 text-blue-600">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M12 15v7" /><path d="M9 19h6" /><circle cx="12" cy="9" r="6" />
                                    </svg>
                                </div>
                                <div v-else-if="event.event === 'Fathers Day'" class="w-6 h-6 text-blue-600">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M16 3h5v5" /><path d="m21 3-6.75 6.75" /><circle cx="10" cy="14" r="6" />
                                    </svg>
                                </div>
                                <div v-else-if="event.event === 'Christmas Day'" class="w-6 h-6 text-blue-600">
                                    <svg fill="none" stroke="currentcolor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                        <path d="M5 14V11.3256C5 7.27977 8.27977 4 12.3256 4V4C15.666 4 18.5835 6.25985 19.4185 9.49427L20.0831 12.0684M16 11L17.6387 12.831M17.05 14C17.0172 14.1616 17 14.3288 17 14.5C17 15.7095 17.8589 16.7184 19 16.95M17.05 14H5C3.89543 14 3 14.8954 3 16V17C3 18.1046 3.89543 19 5 19H17C18.1046 19 19 18.1046 19 17V16.95M17.05 14C17.1401 13.5564 17.3476 13.1554 17.6387 12.831M17.6387 12.831C18.0964 12.3209 18.7607 12 19.5 12C19.7008 12 19.896 12.0237 20.0831 12.0684M20.0831 12.0684C21.1826 12.3311 22 13.3201 22 14.5C22 15.8807 20.8807 17 19.5 17C19.3288 17 19.1616 16.9828 19 16.95" />
                                    </svg>
                                </div>
                                <div v-else-if="event.event === 'Valentines Day'" class="w-6 h-6 text-blue-600">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                                    </svg>
                                </div>
                                <div v-else-if="event.event === 'Easter Sunday'" class="w-6 h-6 text-blue-600">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M13 16a3 3 0 0 1 2.24 5" /><path d="M18 12h.01" /><path d="M18 21h-8a4 4 0 0 1-4-4 7 7 0 0 1 7-7h.2L9.6 6.4a1 1 0 1 1 2.8-2.8L15.8 7h.2c3.3 0 6 2.7 6 6v1a2 2 0 0 1-2 2h-1a3 3 0 0 0-3 3" /><path d="M20 8.54V4a2 2 0 1 0-4 0v3" /><path d="M7.612 12.524a3 3 0 1 0-1.6 4.3" />
                                    </svg>
                                </div>
                                <div v-else class="w-6 h-6 text-blue-600"></div>
                            </div>

                            <!-- Event Details -->
                            <div>
                                <h3 class="text-lg font-semibold text-gray-900 capitalize">
                                    {{ event.name }}
                                </h3>
                                <p class="text-sm text-gray-500">
                                    {{ formatFriendlyDate(event.date) }}
                                </p>
                            </div>
                        </div>

                        <!-- Right Side: Days Until and Reminder Status -->
                        <div class="flex items-center space-x-1 md:space-x-4">
                            <!-- Days Until Badge -->
                            <div class="text-right">
                                <div
v-if="daysUntilNextAnniversary(event.date) < 1"
                                    class="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-red-100 text-red-800 cursor-help relative"
                                    @mouseenter="showTooltip = 'minutes-' + (event.id || event.name + event.event); setTooltipPosition($event)"
                                    @mouseleave="showTooltip = null"
>
                                    Today! 🎉
                                    <!-- Minutes Tooltip -->
                                    <div
v-if="showTooltip === 'minutes-' + (event.id || event.name + event.event)"
                                        class="fixed px-3 py-2 bg-gray-800 text-white text-sm rounded-lg shadow-lg whitespace-nowrap z-[9999] pointer-events-none"
                                        :style="tooltipStyle"
>
                                        {{ formatMinutesUntil(event.date) }} minutes...
                                        <div
                                            class="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"
>
                                        </div>
                                    </div>
                                </div>
                                <div
v-else-if="daysUntilNextAnniversary(event.date) < 2"
                                    class="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-orange-100 text-orange-800 cursor-help relative"
                                    @mouseenter="showTooltip = 'minutes-' + (event.id || event.name + event.event); setTooltipPosition($event)"
                                    @mouseleave="showTooltip = null"
>
                                    Tomorrow
                                    <!-- Minutes Tooltip -->
                                    <div
v-if="showTooltip === 'minutes-' + (event.id || event.name + event.event)"
                                        class="fixed px-3 py-2 bg-gray-800 text-white text-sm rounded-lg shadow-lg whitespace-nowrap z-[9999] pointer-events-none"
                                        :style="tooltipStyle"
>
                                        {{ formatMinutesUntil(event.date) }} minutes...
                                        <div
                                            class="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"
>
                                        </div>
                                    </div>
                                </div>
                                <div
v-else-if="daysUntilNextAnniversary(event.date) < 7"
                                    class="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-yellow-100 text-yellow-800 cursor-help relative"
                                    @mouseenter="showTooltip = 'minutes-' + (event.id || event.name + event.event); setTooltipPosition($event)"
                                    @mouseleave="showTooltip = null"
>
                                    {{ daysUntilNextAnniversary(event.date) }} days
                                    <!-- Minutes Tooltip -->
                                    <div
v-if="showTooltip === 'minutes-' + (event.id || event.name + event.event)"
                                        class="fixed px-3 py-2 bg-gray-800 text-white text-sm rounded-lg shadow-lg whitespace-nowrap z-[9999] pointer-events-none"
                                        :style="tooltipStyle"
>
                                        {{ formatMinutesUntil(event.date) }} minutes...
                                        <div
                                            class="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"
>
                                        </div>
                                    </div>
                                </div>
                                <div
v-else
                                    class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-800 cursor-help relative"
                                    @mouseenter="showTooltip = 'minutes-' + (event.id || event.name + event.event); setTooltipPosition($event)"
                                    @mouseleave="showTooltip = null"
>
                                    {{ daysUntilNextAnniversary(event.date) }} days
                                    <!-- Minutes Tooltip -->
                                    <div
v-if="showTooltip === 'minutes-' + (event.id || event.name + event.event)"
                                        class="fixed px-3 py-2 bg-gray-800 text-white text-sm rounded-lg shadow-lg whitespace-nowrap z-[9999] pointer-events-none"
                                        :style="tooltipStyle"
>
                                        {{ formatMinutesUntil(event.date) }} minutes...
                                        <div
                                            class="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"
>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Reminder Status -->
                            <div class="flex-shrink-0 relative">
                                <div
v-if="!event.reminder"
                                    class="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center cursor-help"
                                    @mouseenter="showTooltip = event.id || event.name + event.event; setTooltipPosition($event)"
                                    @mouseleave="showTooltip = null"
>
                                    <svg
class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24"
>
                                        <path
stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M9.143 17.082a24.248 24.248 0 003.844.148m-3.844-.148a23.856 23.856 0 01-5.455-1.31 8.964 8.964 0 002.3-5.542m3.155 6.852a3 3 0 005.667 1.97m1.965-2.277L21 21m-4.225-4.225a23.81 23.81 0 003.536-1.003A8.967 8.967 0 0118 9.75V9A6 6 0 006.53 6.53m10.245 10.245L6.53 6.53M3 3l3.53 3.53"
/>
                                    </svg>
                                    <!-- Custom Tooltip for Disabled -->
                                    <div
v-if="showTooltip === (event.id || event.name + event.event)"
                                        class="fixed px-3 py-2 bg-gray-800 text-white text-sm rounded-lg shadow-lg whitespace-nowrap z-[9999] pointer-events-none"
                                        :style="tooltipStyle"
>
                                        Notifications disabled
                                        <div
                                            class="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"
>
                                        </div>
                                    </div>
                                </div>
                                <div
v-else
                                    class="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center cursor-help"
                                    @mouseenter="showTooltip = event.id || event.name + event.event; setTooltipPosition($event)"
                                    @mouseleave="showTooltip = null"
>
                                    <svg
class="w-4 h-4 text-green-600" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24"
>
                                        <path
stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
/>
                                    </svg>
                                    <!-- Custom Tooltip for Enabled -->
                                    <div
v-if="showTooltip === (event.id || event.name + event.event)"
                                        class="fixed px-3 py-2 bg-gray-800 text-white text-sm rounded-lg shadow-lg whitespace-nowrap z-[9999] pointer-events-none"
                                        :style="tooltipStyle"
>
                                        Notifications enabled
                                        <div
                                            class="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"
>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Empty State -->
        <div v-else class="text-center py-16">
            <div class="text-gray-400 text-6xl mb-4">📅</div>
            <h3 class="text-lg font-medium text-gray-600 mb-2">No upcoming events</h3>
            <p class="text-gray-500">Add some friends and family to start tracking important dates!</p>
        </div>
    </div>
</template>

<script>
import { API } from 'aws-amplify';


export default {
    name: 'UpcomingList',
    data() {
        return {
            predefinedEvents: [
                { name: "Mothers Day", event: "Mothers Day", date: this.calculateMothersDay(), show: (this.$store.state.user.data.show_mothers_day === 'true'), reminder: (this.$store.state.user.data.remind_mothers_day === 'true') },
                { name: "Fathers Day", event: "Fathers Day", date: this.calculateFathersDay(), show: (this.$store.state.user.data.show_fathers_day === 'true'), reminder: (this.$store.state.user.data.remind_fathers_day === 'true') },
                { name: "Christmas Day", event: "Christmas Day", date: '2020-12-25', reminder: (this.$store.state.user.data.remind_christmas === 'true') },
                { name: "Valentines Day", event: "Valentines Day", date: '2020-02-14', reminder: (this.$store.state.user.data.remind_valentines === 'true') },
                { name: "Easter Sunday", event: "Easter Sunday", date: this.getNextEasterSunday(), reminder: (this.$store.state.user.data.remind_easter === 'true') },
            ],
            friendEvents: [],
            showTooltip: null,
            tooltipStyle: {}
        }
    },
    components: {
    },
    computed: {
        friends() {
            return this.$store.state.friendSortedMap;
        },
        eventsSorted() {
            return this.sortEventsByDate()
        }
    },
    created() {
        this.getFriendEvents();
    },
    mounted() {

    },
    methods: {
        async getFriendEvents() {
            const query = `query MyQuery {
  listFriends(filter: {birthday: {ne: null, attributeExists: true}}) {
    items {
      name
      reminder
      birthday
      anniversary
      anniversaryReminder
    }
  }
}`

            await API.graphql({
                query: query
            }).then((friends) => {
                this.friendEvents.push(...friends.data.listFriends.items)
            })
        },


        calculateMothersDay() {
            const currentYear = new Date().getFullYear();
            const nextYear = currentYear + 1;
            const userCountry = this.$store.state.user.data.country;

            var mayCountryList = ['Australia', "New Zealand", 'Brazil', 'USA', 'Canada', 'India', 'Fiji', 'Singapore', 'South Africa', 'Philippines', 'Netherlands'];
            var lentCountryList = ['UK', 'Ireland', 'Nigeria', 'Scotland', 'Wales']

            if (mayCountryList.includes(userCountry)) {
                var mothersDays = [currentYear, nextYear].map(year => {
                    var date = new Date(year, 4, 1);

                    while (date.getDay() !== 0) {
                        date.setDate(date.getDate() + 1);
                    }

                    date.setDate(date.getDate() + 7);

                    return date;
                });
            } else if (lentCountryList.includes(userCountry)) {
                function easterSunday(Y) {
                    var C = Math.floor(Y / 100);
                    var N = Y - 19 * Math.floor(Y / 19);
                    var K = Math.floor((C - 17) / 25);
                    var I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
                    I = I - 30 * Math.floor((I / 30));
                    I = I - Math.floor(I / 28) * (1 - Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11));
                    var J = Y + Math.floor(Y / 4) + I + 2 - C + Math.floor(C / 4);
                    J = J - 7 * Math.floor(J / 7);
                    var L = I - J;
                    var M = 3 + Math.floor((L + 40) / 44);
                    var D = L + 28 - 31 * Math.floor(M / 4);

                    return new Date(Y, M - 1, D);
                }

                var mothersDays = [currentYear, nextYear].map(year => {
                    var easter = easterSunday(year);
                    var mothersDay = new Date(easter.getTime());
                    mothersDay.setDate(easter.getDate() - 21);
                    return mothersDay;
                });

            } else if (userCountry === 'France') {
                var mothersDays = [currentYear, nextYear].map(year => {
                    var date = new Date(year, 4, 31);

                    while (date.getDay() !== 0) {
                        date.setDate(date.getDate() - 1);
                    }
                    return date;
                });
            } else if (userCountry === 'Mexico') {
                var mothersDays = [currentYear, nextYear].map(year => {
                    var date = new Date(year, 4, 10);
                    return date;
                });
            } else {
                return null;
            }

            var [thisYear, nextYearMotherDay] = mothersDays;

            const today = new Date();

            let result;
            if (this.compareLocalDates(today, thisYear) <= 0) {
                result = this.formatDate(thisYear);
            } else {
                result = this.formatDate(nextYearMotherDay);
            }

            return result;
        },

        calculateFathersDay() {
            const currentYear = new Date().getFullYear();
            const nextYear = currentYear + 1;
            const userCountry = this.$store.state.user.data.country;

            const septCountryList = ['Australia', 'New Zealand', 'Fiji'];
            const juneCountryList = ['USA', 'Canada', 'France', 'UK', 'India', 'Mexico', 'Singapore', 'South Africa', 'Philippines', 'Netherlands', 'Nigeria', 'Ireland', 'Scotland', 'Wales'];

            let fathersDays;

            if (septCountryList.includes(userCountry)) {
                // Australia, New Zealand, Fiji
                fathersDays = [currentYear, nextYear].map(year => {
                    const date = new Date(year, 8, 1); // September 1st (month is 0-indexed)
                    date.setDate(date.getDate() + (7 - date.getDay()) % 7); // Adjust to first Sunday
                    return date;
                });
            } else if (juneCountryList.includes(userCountry)) {
                fathersDays = [currentYear, nextYear].map(year => {
                    var date = new Date(year, 5, 1);

                    var count = 0;
                    while (true) {
                        if (date.getDay() === 0) {
                            count++;
                        }
                        if (count === 3) {
                            break;
                        }
                        date.setDate(date.getDate() + 1);
                    }
                    return date;
                });
            } else if (userCountry === 'Brazil') {
                fathersDays = [currentYear, nextYear].map(year => {
                    var date = new Date(year, 7, 1);

                    var count = 0;
                    while (true) {
                        if (date.getDay() === 0) {
                            count++;
                        }
                        if (count === 2) {
                            break;
                        }
                        date.setDate(date.getDate() + 1);
                    }
                    return date;
                });
            } else {
                return null;
            }

            const [thisYear, nextYearFatherDay] = fathersDays;

            const today = new Date();

            let result;
            if (this.compareLocalDates(today, thisYear) <= 0) {
                result = this.formatDate(thisYear);
            } else {
                result = this.formatDate(nextYearFatherDay);
            }

            return result;
        },

        calculateEasterSunday(year) {
            const a = year % 19;
            const b = Math.floor(year / 100);
            const c = year % 100;
            const d = Math.floor(b / 4);
            const e = b % 4;
            const f = Math.floor((b + 8) / 25);
            const g = Math.floor((b - f + 1) / 3);
            const h = (19 * a + b - d - g + 15) % 30;
            const i = Math.floor(c / 4);
            const k = c % 4;
            const l = (32 + 2 * e + 2 * i - h - k) % 7;
            const m = Math.floor((a + 11 * h + 22 * l) / 451);
            const month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
            const day = ((h + l - 7 * m + 114) % 31) + 1;
            const date = new Date(year, month, day);
            return date;
        },

        getNextEasterSunday() {
            const currentYear = new Date().getFullYear();
            const nextYear = currentYear + 1;

            var easterSundays = [currentYear, nextYear].map(year => this.calculateEasterSunday(year));

            var [thisYear, nextYearEaster] = easterSundays;

            if (new Date() < thisYear) {
                const offset = thisYear.getTimezoneOffset()
                thisYear = new Date(thisYear.getTime() - (offset * 60 * 1000))
                return thisYear.toISOString().split('T')[0];
            } else {
                const offset = nextYearEaster.getTimezoneOffset()
                nextYearEaster = new Date(nextYearEaster.getTime() - (offset * 60 * 1000))
                return nextYearEaster.toISOString().split('T')[0];
            }
        },

        sortEventsByDate() {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            var combinedEvents = [...this.friendEvents, ...this.predefinedEvents];

            var sortedEvents = combinedEvents
                .flatMap(friend => [
                    friend.birthday ? { ...friend, event: 'birthday', date: friend.birthday, reminder: friend.reminder } : null,
                    friend.anniversary ? { ...friend, event: 'anniversary', date: friend.anniversary, reminder: friend.anniversaryReminder } : null,
                    friend.date ? { ...friend, event: friend.event, date: friend.date, reminder: friend.reminder } : null
                ])
                .filter(Boolean)
                .sort(function (a, b) {
                    var eventDateA = new Date(a.date);
                    let nextDateA = new Date(today.getFullYear(), eventDateA.getMonth(), eventDateA.getDate());
                    if (today > nextDateA) {
                        nextDateA.setFullYear(nextDateA.getFullYear() + 1);
                    }
                    var diffMillisA = nextDateA.getTime() - today.getTime();
                    var daysUntilA = Math.ceil(diffMillisA / (1000 * 60 * 60 * 24));

                    var eventDateB = new Date(b.date);
                    let nextDateB = new Date(today.getFullYear(), eventDateB.getMonth(), eventDateB.getDate());
                    if (today > nextDateB) {
                        nextDateB.setFullYear(nextDateB.getFullYear() + 1);
                    }
                    var diffMillisB = nextDateB.getTime() - today.getTime();
                    var daysUntilB = Math.ceil(diffMillisB / (1000 * 60 * 60 * 24));

                    var offsetA = nextDateA.getTimezoneOffset()
                    nextDateA = new Date(nextDateA.getTime() - (offsetA * 60 * 1000))
                    a.date = nextDateA.toISOString().split('T')[0];

                    var offsetB = nextDateB.getTimezoneOffset()
                    nextDateB = new Date(nextDateB.getTime() - (offsetB * 60 * 1000))
                    b.date = nextDateB.toISOString().split('T')[0];

                    return daysUntilA - daysUntilB;
                });


            return sortedEvents.filter(obj => obj.show !== false);;
        },

        daysUntilNextAnniversary(dob) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const eventDate = new Date(dob);

            let nexteventDate = new Date(today.getFullYear(), eventDate.getMonth(), eventDate.getDate());

            if (nexteventDate === today) {
                return 0;
            };

            if (today > nexteventDate) {
                nexteventDate.setFullYear(nexteventDate.getFullYear() + 1);
            }

            const diffMillis = nexteventDate.getTime() - today.getTime();

            return Math.ceil(diffMillis / (1000 * 60 * 60 * 24));
        },

        formatDate(date) {
            const options = { timeZone: 'Australia/Sydney', year: 'numeric', month: '2-digit', day: '2-digit' };
            const [month, day, year] = date.toLocaleDateString('en-US', options).split('/');
            return `${year}-${month}-${day}`;
        },

        formatDateForLog(date) {
            return date.toLocaleString('en-US', { timeZone: 'Australia/Sydney' });
        },

        compareLocalDates(date1, date2) {
            const d1 = new Date(date1.toLocaleDateString('en-US', { timeZone: 'Australia/Sydney' }));
            const d2 = new Date(date2.toLocaleDateString('en-US', { timeZone: 'Australia/Sydney' }));
            return d1 - d2;
        },

        formatFriendlyDate(date) {
            const dateObj = new Date(date);
            const day = dateObj.getDate();
            const month = dateObj.toLocaleString('en-US', { month: 'long' });
            const year = dateObj.getFullYear();

            // Add ordinal suffix to day
            const ordinalSuffix = (day) => {
                if (day > 3 && day < 21) return 'th';
                switch (day % 10) {
                    case 1: return 'st';
                    case 2: return 'nd';
                    case 3: return 'rd';
                    default: return 'th';
                }
            };

            return `${month} ${day}${ordinalSuffix(day)}, ${year}`;
        },

        setTooltipPosition(event) {
            const rect = event.target.getBoundingClientRect();
            this.tooltipStyle = {
                left: (rect.left + rect.width / 2) + 'px',
                top: (rect.top - 10) + 'px',
                transform: 'translate(-50%, -100%)'
            };
        },

        formatMinutesUntil(date) {
            const today = new Date();
            const eventDate = new Date(date);
            const diffMillis = eventDate.getTime() - today.getTime();
            const minutesUntil = Math.ceil(diffMillis / (1000 * 60));
            return minutesUntil.toLocaleString();
        }
    }
}
</script>